import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Layout from 'src/components/Layout/Layout';

export function NotificationsPage() {
  const { t } = useTranslation();

  useEffect(() => {
    // hack to tell headway that we saw the notifications:
    // before, we used this widget directly and displayed it in the top nav. people clicked on it,
    // headway showed its own ui and it registered the read. now that we're in control of the ui via
    // the "Notifications" tab in the side nav, we have to pretend that someone clicked headway's
    // widget to make sure the notifications are marked read.
    // the widget is rendered as a rightItem in the SideNav so that it displays the unread count,
    // but we're doing this here so that the notifications are only marked read once this page
    // is actually rendered.
    const headwayElement = document.getElementById('HW_badge_cont');
    if (headwayElement) {
      headwayElement.style.pointerEvents = 'auto !important';
      headwayElement.click(); // "show" notifications so read is recorded
      headwayElement.click(); // "hide" notifications
      headwayElement.style.pointerEvents = 'none !important';
    }
  }, []);

  return (
    <Layout
      title={t('main_nav.notifications')}
      className="NotificationsPage"
      contentStyle={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingBottom: 0,
      }}
    >
      <h1 className="h2 lh-1">Notifications</h1>

      <iframe
        src="https://updates.fora.io"
        referrerPolicy="strict-origin"
        sandbox="allow-same-origin allow-scripts allow-top-navigation allow-popups allow-forms allow-popups-to-escape-sandbox"
        tabIndex={0}
        aria-hidden={false}
        style={{ maxWidth: '648px', width: '100%', flexGrow: 1 }}
      ></iframe>
    </Layout>
  );
}
